import React, { useEffect } from 'react';
import { HiOutlineX } from 'react-icons/hi';

export default function Modal({ show, onClose, title, icon, size, children, footer }) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <button type="button" className="modal-overlay-btn" onClick={onClose} aria-label="Fermer" tabIndex={-1} style={{ position: 'absolute', inset: 0, background: 'transparent', border: 'none', cursor: 'default', zIndex: 0, outline: 'none' }} />
      <dialog className={`modal-container modal-${size || 'md'}`} open aria-modal="true">
        <div className="modal-header-custom">
          <h5 className="modal-title-custom">
            {icon && <span className="modal-icon">{icon}</span>}
            {title}
          </h5>
          <button className="modal-close" onClick={onClose}>
            <HiOutlineX />
          </button>
        </div>
        <div className="modal-body-custom">
          {children}
        </div>
        {footer && (
          <div className="modal-footer-custom">
            {footer}
          </div>
        )}
      </dialog>
    </div>
  );
}

export function ConfirmModal({ show, onClose, onConfirm, title, message, confirmText, confirmVariant }) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <button type="button" className="modal-overlay-btn" onClick={onClose} aria-label="Fermer" tabIndex={-1} style={{ position: 'absolute', inset: 0, background: 'transparent', border: 'none', cursor: 'default', zIndex: 0, outline: 'none' }} />
      <dialog className="modal-container modal-sm" open aria-modal="true">
        <div className="modal-header-custom">
          <h5 className="modal-title-custom">{title || 'Confirmation'}</h5>
          <button className="modal-close" onClick={onClose}><HiOutlineX /></button>
        </div>
        <div className="modal-body-custom">
          <p className="mb-0">{message}</p>
        </div>
        <div className="modal-footer-custom">
          <button className="btn btn-outline-secondary btn-sm" onClick={onClose}>Annuler</button>
          <button className={`btn btn-${confirmVariant || 'danger'} btn-sm`} onClick={onConfirm}>
            {confirmText || 'Confirmer'}
          </button>
        </div>
      </dialog>
    </div>
  );
}
